import { render } from "./AjustesDestino.vue?vue&type=template&id=194619ed&scoped=true"
import script from "./AjustesDestino.vue?vue&type=script&lang=js"
export * from "./AjustesDestino.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./AjustesDestino.vue?vue&type=style&index=1&id=194619ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194619ed"]])

export default __exports__